"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorElement = exports.handleSize = exports.handleUtility = void 0;
var classnames_1 = __importDefault(require("classnames"));
var styled_components_1 = __importDefault(require("styled-components"));
var Variables_1 = require("../Variables");
var getClass = function (type, size, dir) {
    return ['t2', type, dir, size === 'md' ? null : size].filter(function (v) { return v; }).join('-');
};
function handleUtility(props, baseClass) {
    var _a;
    var _b = props, className = _b.className, flex = _b.flex, flexRow = _b.flexRow, flexCol = _b.flexCol, block = _b.block, margin = _b.margin, marginTop = _b.marginTop, marginBottom = _b.marginBottom, marginLeft = _b.marginLeft, marginRight = _b.marginRight, padding = _b.padding, paddingTop = _b.paddingTop, paddingBottom = _b.paddingBottom, paddingLeft = _b.paddingLeft, paddingRight = _b.paddingRight, rest = __rest(_b, ["className", "flex", "flexRow", "flexCol", "block", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight", "padding", "paddingTop", "paddingBottom", "paddingLeft", "paddingRight"]);
    return __assign({ className: (0, classnames_1.default)(baseClass, className, (_a = {
                't2-flex-row': flex || flexRow,
                't2-flex-column': flexCol,
                't2-block': block
            },
            _a[getClass('margin', margin)] = margin,
            _a[getClass('margin', marginTop, 'top')] = marginTop,
            _a[getClass('margin', marginBottom, 'bottom')] = marginBottom,
            _a[getClass('margin', marginLeft, 'left')] = marginLeft,
            _a[getClass('margin', marginRight, 'right')] = marginRight,
            _a[getClass('padding', padding)] = padding,
            _a[getClass('padding', paddingTop, 'top')] = paddingTop,
            _a[getClass('padding', paddingBottom, 'bottom')] = paddingBottom,
            _a[getClass('padding', paddingLeft, 'left')] = paddingLeft,
            _a[getClass('padding', paddingRight, 'right')] = paddingRight,
            _a)) }, rest);
}
exports.handleUtility = handleUtility;
function handleSize(props) {
    var _a = props, xxs = _a.xxs, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, xxl = _a.xxl, className = _a.className, rest = __rest(_a, ["xxs", "xs", "sm", "md", "lg", "xl", "xxl", "className"]);
    return __assign({ className: (0, classnames_1.default)(className, {
            't2-xxs': xxs,
            't2-xs': xs,
            't2-sm': sm,
            't2-md': md,
            't2-lg': lg,
            't2-xl': xl,
            't2-xxl': xxl,
        }) }, rest);
}
exports.handleSize = handleSize;
exports.ColorElement = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var color = _a.color;
    return color &&
        "\n    color: ".concat(Variables_1.color[color], ";\n  ");
});
var templateObject_1;
